var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import QuestionnaireOrg from "../../../organisms/jsQuestionnaire/jsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GeneralSkillsAction, GeneralSkillsFormAction, } from "../../../../redux/actions/job_seeker_questionnaire";
import { questionnaireTimer } from "../../../../utils/QuestionnaireTimer";
import { getQuestionnaireAttemptVariant, getQuestionnaireProgressWidth, } from "../../../../utils/questionnaireProgress";
/**
 * The General Skills Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function GeneralSkillsQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(''), error = _a[0], setError = _a[1];
    var _b = useState(false), isSubmitting = _b[0], setIsSubmitting = _b[1];
    //using selector hook to fetch data from the reducer
    var _c = useSelector(function (state) { return state.rootReducer.JobSeekerQuestionnaireReducer; }), generalSkillsData = _c.generalSkillsData, error_generalSkills = _c.error_generalSkills, loading = _c.loading, generalSkillsFormData = _c.generalSkillsFormData, success_generalSkills_form = _c.success_generalSkills_form;
    var loginData = useSelector(function (state) { return state.rootReducer.userReducer; }).loginData;
    var quesAttemptDetails = useSelector(function (state) { return state.rootReducer.dashboardReducer.quesAttemptDetails; });
    useEffect(function () {
        questionnaireTimer.startSection("General Skills");
        // Antecedents prefetches this section already; only fetch if it's
        // not already cached in the store (e.g. direct navigation to this page).
        if (!generalSkillsData || generalSkillsData.length === 0) {
            dispatch(GeneralSkillsAction());
        }
    }, [dispatch]);
    //function to submit the input user data
    var handleFormSubmit = function (formData) {
        questionnaireTimer.endSection("General Skills");
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] = DOMPurify.sanitize(formData[key]);
            return acc;
        }, {});
        setIsSubmitting(true);
        dispatch(GeneralSkillsFormAction(sanitizedData, loginData));
    };
    var handleBackBtn = function () {
        navigate("/questionnaire/knowledge");
    };
    useEffect(function () {
        if (success_generalSkills_form && isSubmitting) {
            navigate("/questionnaire/confidence");
        }
    }, [success_generalSkills_form, isSubmitting, navigate]);
    return (_jsxs("div", __assign({ className: "" }, { children: [error && _jsx("div", __assign({ className: "error-message" }, { children: error })), _jsx(QuestionnaireOrg, { title: "General Skills", content: "We are now interested in your general skills and confidence in preparing for and searching for work.", data: generalSkillsData, responses: generalSkillsFormData, loading: !generalSkillsData || generalSkillsData.length === 0, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "generalSkills-w", width: getQuestionnaireProgressWidth("generalSkills", getQuestionnaireAttemptVariant(quesAttemptDetails)) })] })));
}
export default GeneralSkillsQuestionnaire;
